<template>
  <!-- Float -->
  <!-- Top -->
  <div style="position: absolute; right: 10px; top: 10px; z-index: 2">
    <div class="d-flex flex-column align-end" style="gap: 4px">
      <!-- สำหรับ Back Mcommerce -->
      <v-btn
        v-if="false"
        icon
        elevation="4"
        large
        class="float-btn"
        style="background-color: #2196f3"
        @mouseenter="onMouseEnterFloat('home')"
        @mouseleave="onMouseLeaveFloat"
        @click="onClickMenuFloat('home')"
      >
        <div
          class="speech-bubble"
          :class="{ 'is-active': activeFloat === 'home' }"
          :style="{
            '--bg-color': '#FAFAFA',
            '--font-color': '#000000',
          }"
        >
          <div class="text-truncate text-none" style="font-size: 12px">
            {{ $t("microsite.textBackHome") }}
          </div>
        </div>
        <v-icon color="white"> mdi-home-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="isShowRedirectHome"
        rounded
        small
        style="
          height: 32px;
          padding: 0px 8px 0px 4px;
          box-shadow: 8px 4px 16px -4px #2196f380;
        "
        @click="onClickMenuFloat('home', true)"
      >
        <div class="d-flex align-center" style="gap: 8px">
          <div
            style="
              width: 24px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #2196f3;
              border-radius: 50%;
            "
          >
            <v-icon color="white" small> mdi-home-outline </v-icon>
          </div>
          <div class="text-none">
            {{ $t("microsite.textBackHome") }}
          </div>
          <div style="margin-bottom: 1px">
            <v-icon small color="#2196f3"> mdi-chevron-right </v-icon>
          </div>
        </div>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getLandingPage } from "../../../../config/general-function";

export default {
  inject: ["isAppLoading"],
  props: {
    pageName: {
      default: "",
    },
    campaign: {
      default: () => ({}),
    },
    isShowRedirectHome: {
      default: false,
    },
  },
  data: () => ({
    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  mounted() {
    window.addEventListener("click", this.onOutsideClick);
    const hoverQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
    this.isHoverableDevice = hoverQuery.matches;
    hoverQuery.addEventListener("change", (e) => {
      this.isHoverableDevice = e.matches;
    });
  },
  beforeDestroy() {
    window.removeEventListener("click", this.onOutsideClick);
  },
  methods: {
    onOutsideClick(e) {
      if (!e.target.closest(".float-btn")) {
        this.activeFloat = null;
      }
    },
    onMouseEnterFloat(name) {
      if (this.isHoverableDevice) {
        this.activeFloat = name;
      }
    },
    onMouseLeaveFloat() {
      if (this.isHoverableDevice) {
        this.activeFloat = null;
      }
    },
    async onClickMenuFloat(name, bypass = false) {
      if (!this.isHoverableDevice && !bypass) {
        if (this.activeFloat != name) {
          this.secondClick = false;
        } else {
          this.secondClick = true;
        }
        this.activeFloat = name;
        if (!this.secondClick) {
          return;
        }
      }
      if (name == "home") {
        const landing_page = getLandingPage();
        const targetRoute = this.$router.resolve({
          name: landing_page,
        });
        window.location.href = targetRoute.href;
      }
    },
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
  },
};
</script>

<style scoped>
.speech-bubble {
  position: absolute;
  top: 50%;
  right: 100%;
  z-index: 1;
  margin-right: 8px;
  padding: 4px 12px;

  background-color: var(--bg-color, #000000);
  color: var(--font-color, #ffffff);

  border-radius: 18px;
  white-space: nowrap;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  pointer-events: none;

  opacity: 0;
  visibility: hidden;
  transform: translateY(-50%) translateX(10px) scale(0.8);
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.speech-bubble.is-active {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) translateX(0) scale(1);
}

.float-btn {
  position: relative;
}
</style>